module.exports = __webpack_public_path__ + "website/img/jepaas_bg.be571188.png";